var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 40,
    viewBox: "0 0 132 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 26.3947C5.83984 26.3947 6.53235 19.4346 14.0122 15.3376C14.0122 15.3376 22.8034 10.0141 22.5044 5.33398C22.5044 5.33398 26.3957 10.8673 21.453 16.5835C21.453 16.5835 18.6687 19.9432 13.8438 20.8861C13.8438 20.886 9.15002 21.4891 5.83984 26.3947Z",
    fill: "url(#paint0_linear_473_10648)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3359 23.4369C10.3359 23.4369 16.4095 20.1104 23.9544 24.0831C23.9544 24.0831 33.2371 28.4671 36.8916 25.5889C36.8916 25.5889 34.5566 31.9586 27.1137 31.0222C27.1137 31.0222 22.8068 30.5731 19.3277 27.0564C19.3277 27.0565 16.2013 23.4591 10.3359 23.4369Z",
    fill: "url(#paint1_linear_473_10648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93555 25.8743C5.93555 25.8743 7.14104 18.9865 14.9023 15.469C14.9023 15.469 24.0627 10.8284 24.1106 6.13867C24.1106 6.13867 27.582 11.9517 22.2304 17.2765C22.2304 17.2765 19.2051 20.4151 14.3239 20.9888C14.3239 20.9888 9.5998 21.2336 5.93555 25.8743Z",
    fill: "url(#paint2_linear_473_10648)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6387 23.2662C10.6387 23.2662 16.9407 20.4107 24.1704 24.945C24.1704 24.945 33.1027 30.0212 36.9602 27.429C36.9602 27.429 34.1607 33.6032 26.8081 32.1046C26.8081 32.1046 22.5464 31.3295 19.3375 27.5582C19.3375 27.5582 16.4856 23.734 10.6387 23.2662Z",
    fill: "url(#paint3_linear_473_10648)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6937 29.3913C15.6937 32.305 13.3624 34.6669 10.4869 34.6669C7.61133 34.6669 5.28027 32.305 5.28027 29.3913C5.28027 26.4772 7.61133 24.1152 10.4869 24.1152C13.3624 24.1152 15.6937 26.4772 15.6937 29.3913Z",
    fill: "url(#paint4_linear_473_10648)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8429 22.1809C39.6149 22.062 39.5996 21.994 39.5996 21.5353C39.5996 20.6874 39.6655 20.0084 39.68 19.7363C39.6969 19.5504 39.7295 19.4651 39.8102 19.4651C39.9072 19.4651 39.9236 19.5159 39.9236 19.6523C39.9236 19.8046 39.9236 20.0432 39.9731 20.2798C40.2156 21.5356 41.285 22.0112 42.3693 22.0112C43.9255 22.0112 44.6851 20.8401 44.6851 19.7538C44.6851 18.5833 44.2165 17.9045 42.8232 16.6992L42.0937 16.0706C40.3772 14.594 39.9892 13.5417 39.9892 12.3884C39.9892 10.5735 41.2847 9.33398 43.3417 9.33398C43.973 9.33398 44.4424 9.40197 44.8467 9.50357C45.1551 9.572 45.285 9.58828 45.4134 9.58828C45.5447 9.58828 45.5761 9.62279 45.5761 9.70706C45.5761 9.79163 45.512 10.3525 45.512 11.5055C45.512 11.7776 45.4791 11.8965 45.3984 11.8965C45.3014 11.8965 45.285 11.8121 45.2685 11.6762C45.2521 11.473 45.1551 11.015 45.0581 10.8269C44.9612 10.6406 44.523 9.92775 43.0332 9.92775C41.916 9.92775 41.0414 10.6579 41.0414 11.8965C41.0414 12.8632 41.4621 13.4746 43.0174 14.748L43.4706 15.1214C45.3818 16.6992 45.8355 17.7512 45.8355 19.1086C45.8355 19.8049 45.5758 21.0943 44.4582 21.9261C43.7621 22.436 42.8867 22.6392 42.0127 22.6392C41.2512 22.6392 40.5071 22.5201 39.8429 22.1809Z",
    fill: "url(#paint5_linear_473_10648)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2483 11.2168C52.1519 11.2168 52.0871 11.3008 51.9092 11.7763L48.557 20.8055C48.2818 21.5347 48.0053 22.0442 47.3576 22.1284C47.2457 22.1458 47.0339 22.1629 46.9375 22.1629C46.8726 22.1629 46.8076 22.2137 46.8076 22.2817C46.8076 22.3664 46.9056 22.4005 47.083 22.4005C47.471 22.4005 47.9178 22.378 48.2158 22.3629C48.3646 22.3555 48.4763 22.3499 48.5248 22.3499C48.5905 22.3499 48.7586 22.3583 48.9578 22.3682C49.2473 22.3827 49.6022 22.4005 49.8039 22.4005C49.9339 22.4005 50.0151 22.3664 50.0151 22.2817C50.0151 22.2137 49.9816 22.1629 49.8682 22.1629H49.7389C49.4963 22.1629 49.253 22.0613 49.253 21.7717C49.253 21.5175 49.3335 21.162 49.4634 20.8055L50.2742 18.4973C50.305 18.4127 50.3553 18.3782 50.4202 18.3782H53.7068C53.7883 18.3782 53.8041 18.3957 53.8367 18.4628L55.1159 21.7721C55.2127 22.0108 55.0682 22.1287 54.9875 22.1632C54.9756 22.1693 54.9648 22.1744 54.955 22.1788C54.9109 22.1991 54.889 22.2092 54.889 22.2649C54.889 22.3392 55.0624 22.3485 55.2906 22.3607C55.3234 22.3624 55.3573 22.3644 55.3919 22.3664C56.3798 22.4005 57.4325 22.4005 57.6428 22.4005C57.8038 22.4005 57.9665 22.3664 57.9665 22.2817C57.9665 22.1966 57.8696 22.1629 57.7891 22.1629C57.6428 22.1629 57.4325 22.1458 57.2219 22.0784C56.9133 21.9757 56.5247 21.7887 56.0068 20.4996C55.5531 19.3642 54.7201 17.2148 53.9871 15.3237C53.3072 13.5692 52.7134 12.0369 52.5884 11.7429C52.5597 11.6787 52.5347 11.6195 52.5121 11.5654C52.4202 11.3473 52.3654 11.2168 52.2483 11.2168ZM53.545 17.682C53.56 17.75 53.56 17.7834 53.4959 17.7834H50.6123C50.5644 17.7834 50.548 17.75 50.5644 17.682L51.8928 13.7284C51.9743 13.508 52.0553 13.508 52.1361 13.7284L53.545 17.682Z",
    fill: "url(#paint6_linear_473_10648)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8911 20.5504C70.9395 21.0601 71.0371 21.8408 71.6193 22.0443C72.0253 22.1802 72.3972 22.1802 72.5435 22.1802C72.6085 22.1802 72.6569 22.2138 72.6569 22.2818C72.6569 22.3665 72.5271 22.4179 72.3658 22.4179C72.0421 22.4179 70.4536 22.4006 69.9356 22.3498C69.5955 22.3163 69.5297 22.2649 69.5297 22.1968C69.5297 22.1461 69.5626 22.094 69.6275 22.0786C69.7089 22.0614 69.7253 21.8411 69.6928 21.5687L69.013 14.2369H68.9801L65.5462 21.603C65.2551 22.231 65.1746 22.3665 65.0448 22.3665C64.9146 22.3665 64.8345 22.231 64.558 21.7049C64.1866 20.9921 63.2459 19.1422 62.8908 18.3613C62.4692 17.4446 61.3191 15.0185 61.0758 14.4247H61.0118L60.4601 20.9416C60.4443 21.162 60.4443 21.4326 60.4443 21.6712C60.4443 21.8905 60.5745 22.0269 60.7848 22.0786C61.0265 22.1462 61.2387 22.1633 61.3355 22.1633C61.3831 22.1633 61.4493 22.2141 61.4493 22.2649C61.4493 22.3665 61.3523 22.4009 61.1892 22.4009C60.6552 22.4009 59.9751 22.3501 59.8617 22.3501C59.7307 22.3501 59.0518 22.4009 58.6631 22.4009C58.5168 22.4009 58.4189 22.3668 58.4189 22.2649C58.4189 22.2141 58.4848 22.1633 58.5652 22.1633C58.6788 22.1633 58.7756 22.1461 58.9859 22.1116C59.4563 22.0269 59.4727 21.5008 59.5376 20.9589L60.5745 11.5395C60.5909 11.3871 60.6552 11.2852 60.7353 11.2852C60.8333 11.2852 60.9475 11.336 61.0265 11.5047L65.3358 20.466L69.4822 11.5221C69.5465 11.3868 69.6114 11.2852 69.7092 11.2852C69.8062 11.2852 69.8869 11.4031 69.9195 11.6751L70.8911 20.5504Z",
    fill: "url(#paint7_linear_473_10648)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3071 20.5167C79.1343 18.5832 80.9968 13.6616 81.3044 12.6268C81.3697 12.4058 81.4345 12.2014 81.4345 12.0835C81.4345 11.9647 81.3861 11.8292 81.2406 11.7775C81.0779 11.7267 80.9161 11.7267 80.7539 11.7267C80.6733 11.7267 80.5921 11.6759 80.5921 11.6079C80.5921 11.5231 80.6889 11.4883 80.9161 11.4883C81.4825 11.4883 82.1317 11.5226 82.3091 11.5226C82.389 11.5226 83.0053 11.4883 83.4272 11.4883C83.5717 11.4883 83.6534 11.5226 83.6534 11.5908C83.6534 11.6588 83.6049 11.7267 83.4912 11.7267C83.3943 11.7267 83.0706 11.7267 82.8109 11.8963C82.617 12.0327 82.389 12.2359 82.0176 13.2197C81.8555 13.6281 81.1602 15.3583 80.4292 17.1232C79.5552 19.2284 78.9239 20.7893 78.6002 21.5015C78.2122 22.3673 78.1302 22.5877 77.9845 22.5877C77.8224 22.5877 77.7254 22.4014 77.4502 21.7059L73.9522 12.8635C73.6285 12.0503 73.4328 11.8968 72.9639 11.7778C72.7363 11.727 72.4939 11.727 72.4132 11.727C72.3326 11.727 72.2998 11.6422 72.2998 11.5911C72.2998 11.5058 72.4443 11.4886 72.6728 11.4886C73.352 11.4886 74.162 11.5231 74.34 11.5231C74.4854 11.5231 75.1178 11.4886 75.6684 11.4886C75.9281 11.4886 76.0564 11.5231 76.0564 11.5911C76.0564 11.659 76.0089 11.727 75.912 11.727C75.7491 11.727 75.5221 11.7444 75.3922 11.7952C75.2477 11.8626 75.2312 11.9474 75.2312 12.0503C75.2312 12.2362 75.409 12.6773 75.6194 13.2542L78.3071 20.5167Z",
    fill: "url(#paint8_linear_473_10648)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7587 15.6649C85.7587 13.4248 85.7587 13.0172 85.7258 12.5592C85.6947 12.0674 85.6133 11.8304 85.1438 11.7622C85.0305 11.7448 84.7872 11.7277 84.6583 11.7277C84.6088 11.7277 84.5439 11.6598 84.5439 11.609C84.5439 11.5241 84.6088 11.4893 84.7708 11.4893C85.4185 11.4893 86.3427 11.5236 86.423 11.5236C86.5199 11.5236 89.5008 11.541 89.8248 11.5236C90.0992 11.5062 90.3583 11.4563 90.4708 11.4391C90.5367 11.4219 90.6021 11.3711 90.6664 11.3711C90.7141 11.3711 90.7305 11.4391 90.7305 11.5062C90.7305 11.6087 90.6497 11.7782 90.6189 12.1849C90.6021 12.3212 90.5695 12.9661 90.5367 13.1356C90.5211 13.205 90.4708 13.288 90.4068 13.288C90.3259 13.288 90.2931 13.2201 90.2931 13.1019C90.2931 12.9997 90.2766 12.7636 90.2125 12.593C90.1156 12.3554 89.9693 12.2538 89.1922 12.1522C88.9497 12.1179 87.2975 12.1002 87.1347 12.1002C87.0704 12.1002 87.054 12.1522 87.054 12.2538V16.1738C87.054 16.2743 87.054 16.326 87.1347 16.326C87.3139 16.326 89.1922 16.326 89.5164 16.2917C89.8565 16.2591 90.0662 16.2417 90.2125 16.0885C90.3095 15.9869 90.3744 15.9026 90.4229 15.9026C90.4705 15.9026 90.504 15.9352 90.504 16.0214C90.504 16.1061 90.4229 16.3433 90.3897 16.8189C90.358 17.1076 90.3256 17.6508 90.3256 17.7518C90.3256 17.8706 90.2927 18.023 90.1964 18.023C90.1315 18.023 90.0986 17.9731 90.0986 17.8877C90.0986 17.7516 90.0986 17.5992 90.0346 17.4124C89.9852 17.2092 89.8559 17.0393 89.3048 16.9722C88.9167 16.9205 87.3941 16.9029 87.1509 16.9029C87.0701 16.9029 87.054 16.9549 87.054 17.0045V18.2098C87.054 18.7033 87.0374 20.3815 87.054 20.6707C87.0869 21.6379 87.3469 21.8251 88.7549 21.8251C89.1274 21.8251 89.8081 21.8251 90.1806 21.6727C90.5528 21.5022 90.747 21.2482 90.8283 20.671C90.8604 20.5015 90.8933 20.4507 90.9737 20.4507C91.0542 20.4507 91.0707 20.5694 91.0707 20.671C91.0707 20.7726 90.9573 21.7564 90.8768 22.0629C90.7798 22.4366 90.6335 22.4366 90.0828 22.4366C89.0143 22.4366 88.1888 22.4021 87.6051 22.3849C87.0066 22.3515 86.6326 22.3515 86.423 22.3515C86.3903 22.3515 86.1148 22.3515 85.8072 22.368C85.5316 22.3852 85.2079 22.4021 84.9807 22.4021C84.8348 22.4021 84.754 22.3681 84.754 22.2833C84.754 22.2325 84.7866 22.1646 84.8674 22.1646C84.9967 22.1646 85.1747 22.1129 85.3049 22.0952C85.5801 22.0458 85.613 21.7561 85.6779 21.3329C85.7587 20.7378 85.7587 19.602 85.7587 18.2098V15.6649Z",
    fill: "url(#paint9_linear_473_10648)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6498 12.5587C94.6827 13.0166 94.6827 13.4242 94.6827 15.6643H94.683V18.2092C94.683 19.6014 94.683 20.7373 94.6007 21.3322C94.5989 21.3448 94.5971 21.3572 94.5951 21.3697C94.5346 21.7715 94.4957 22.0297 94.2296 22.0947C94.1002 22.1295 93.922 22.164 93.7921 22.164C93.7113 22.164 93.6784 22.232 93.6784 22.2828C93.6784 22.3675 93.7601 22.4016 93.9054 22.4016C94.1316 22.4016 94.4715 22.3847 94.7636 22.3675C94.9834 22.3675 95.1848 22.358 95.2839 22.3533C95.3164 22.3518 95.3379 22.3507 95.3455 22.3507C95.412 22.3507 95.8978 22.3844 96.5127 22.4361C96.6319 22.4424 96.7565 22.4495 96.8845 22.4568C97.4179 22.487 98.0087 22.5205 98.5054 22.5205C100.934 22.5205 102.213 21.5185 102.83 20.8574C103.623 20.0087 104.368 18.6171 104.368 16.801C104.368 15.0876 103.688 13.8815 102.975 13.1354C101.396 11.4659 99.0068 11.4794 97.5396 11.4875C97.4414 11.4881 97.3474 11.4887 97.2579 11.4887C96.6724 11.4887 96.056 11.5053 95.6796 11.5155C95.5142 11.52 95.3952 11.5231 95.3455 11.5231C95.3245 11.5231 95.2463 11.5209 95.1308 11.5173C94.8029 11.5075 94.1737 11.4887 93.6948 11.4887C93.5335 11.4887 93.4668 11.5234 93.4668 11.6084C93.4668 11.6592 93.5335 11.7272 93.5812 11.7272C93.7109 11.7272 93.9528 11.7442 94.0661 11.7617C94.5364 11.8297 94.6178 12.0668 94.6498 12.5587ZM95.9951 20.3655C95.9785 20.093 95.9785 18.7529 95.9785 17.2249H95.9782V12.406C95.9782 12.2361 96.0259 12.167 96.1556 12.1173C96.2855 12.0665 96.7394 12.0157 97.0149 12.0157C98.715 12.0157 100.287 12.2016 101.63 13.6283C102.213 14.238 102.975 15.4093 102.975 17.2422C102.975 18.5663 102.603 19.941 101.858 20.6705C100.999 21.5188 99.8331 21.9772 98.5221 21.9772C96.8367 21.9772 96.3337 21.6721 96.1561 21.4009C96.0435 21.2473 96.0101 20.7223 95.9951 20.3655Z",
    fill: "url(#paint10_linear_473_10648)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.239 20.4332C108.272 21.621 108.4 21.9778 108.79 22.0803C109.048 22.1476 109.373 22.1648 109.503 22.1648C109.567 22.1648 109.617 22.2156 109.617 22.2836C109.617 22.3683 109.518 22.4025 109.357 22.4025C108.547 22.4025 107.981 22.3517 107.85 22.3517C107.721 22.3517 107.121 22.4025 106.473 22.4025C106.328 22.4025 106.246 22.3852 106.246 22.2836C106.246 22.2156 106.296 22.1648 106.36 22.1648C106.473 22.1648 106.733 22.1476 106.943 22.0803C107.299 21.9778 107.348 21.5874 107.348 20.2808V12.0165C107.348 11.4394 107.429 11.2871 107.543 11.2871C107.705 11.2871 107.948 11.5755 108.092 11.7279C108.32 11.9657 110.393 14.2731 112.596 16.6487C114.005 18.1766 115.528 19.8908 115.965 20.3661L115.819 13.1361C115.804 12.2021 115.723 11.8801 115.284 11.7959C115.025 11.7451 114.701 11.7279 114.589 11.7279C114.491 11.7279 114.476 11.6429 114.476 11.5918C114.476 11.5064 114.589 11.4893 114.75 11.4893C115.398 11.4893 116.078 11.5238 116.24 11.5238C116.403 11.5238 116.873 11.4893 117.455 11.4893C117.601 11.4893 117.715 11.5064 117.715 11.5918C117.715 11.6426 117.65 11.7279 117.552 11.7279C117.488 11.7279 117.374 11.7279 117.212 11.7622C116.743 11.8629 116.71 12.1526 116.71 13.0171L116.678 21.4686C116.678 22.4194 116.661 22.504 116.564 22.504C116.419 22.504 116.273 22.3852 115.479 21.6213C115.334 21.4852 113.277 19.3658 111.77 17.7187C110.118 15.9032 108.515 14.1379 108.077 13.6291L108.239 20.4332Z",
    fill: "url(#paint11_linear_473_10648)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.641 11.2168C123.544 11.2168 123.479 11.3008 123.301 11.7763L119.951 20.8055C119.675 21.5347 119.4 22.0442 118.751 22.1284C118.639 22.1458 118.427 22.1629 118.33 22.1629C118.265 22.1629 118.2 22.2137 118.2 22.2817C118.2 22.3664 118.297 22.4005 118.475 22.4005C118.864 22.4005 119.311 22.378 119.609 22.3629C119.757 22.3555 119.869 22.3499 119.917 22.3499C119.984 22.3499 120.152 22.3583 120.352 22.3682C120.641 22.3827 120.995 22.4005 121.196 22.4005C121.326 22.4005 121.407 22.3664 121.407 22.2817C121.407 22.2137 121.375 22.1629 121.262 22.1629H121.131C120.889 22.1629 120.646 22.0613 120.646 21.7717C120.646 21.5175 120.727 21.162 120.856 20.8055L121.667 18.4973C121.698 18.4127 121.746 18.3782 121.812 18.3782H125.099C125.181 18.3782 125.198 18.3957 125.23 18.4628L126.509 21.7721C126.606 22.0108 126.461 22.1287 126.379 22.1632C126.368 22.1692 126.357 22.1739 126.348 22.1783C126.303 22.1989 126.282 22.2087 126.282 22.2649C126.282 22.3391 126.456 22.3484 126.683 22.3607C126.715 22.3624 126.749 22.3644 126.784 22.3664C127.772 22.4005 128.826 22.4005 129.035 22.4005C129.197 22.4005 129.359 22.3664 129.359 22.2817C129.359 22.1966 129.262 22.1629 129.181 22.1629C129.035 22.1629 128.826 22.1458 128.613 22.0784C128.306 21.9757 127.918 21.7887 127.4 20.4996C126.946 19.3642 126.113 17.2148 125.38 15.3237C124.7 13.5692 124.107 12.0369 123.982 11.7429C123.952 11.6777 123.927 11.6174 123.904 11.5626C123.812 11.3462 123.758 11.2168 123.641 11.2168ZM124.938 17.682C124.953 17.75 124.953 17.7834 124.889 17.7834H122.005C121.958 17.7834 121.941 17.75 121.958 17.682L123.286 13.7284C123.365 13.508 123.448 13.508 123.529 13.7284L124.938 17.682Z",
    fill: "url(#paint12_linear_473_10648)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.132 28.1613C92.4846 28.26 92.7443 28.3798 92.912 28.5227C93.1405 28.7293 93.2542 28.9836 93.2542 29.2824C93.2542 29.5617 93.1818 29.8065 93.0403 30.0165C92.8967 30.226 92.71 30.3871 92.479 30.4996C92.248 30.6122 92.0045 30.6676 91.7513 30.6676C91.4159 30.6676 91.0985 30.5761 90.799 30.3918C90.4997 30.2024 90.3486 29.9949 90.3486 29.7692C90.3486 29.7094 90.37 29.6513 90.4113 29.5986C90.4531 29.5454 90.5034 29.5202 90.5608 29.5202C90.6321 29.5202 90.7331 29.6033 90.8633 29.7692C91.0163 29.9425 91.1527 30.0578 91.2744 30.1146C91.4782 30.2156 91.6634 30.2664 91.8285 30.2664C92.0439 30.2664 92.2405 30.2009 92.4188 30.0716C92.5974 29.9425 92.6869 29.7673 92.6869 29.5469C92.6869 29.3052 92.6031 29.1412 92.4388 29.0553C92.2725 28.9685 92.0039 28.8773 91.6317 28.7798C91.2601 28.683 90.9779 28.5566 90.7849 28.4023C90.5911 28.249 90.4938 27.9977 90.4938 27.6513C90.4938 27.286 90.6401 26.982 90.9327 26.7383C91.1843 26.5246 91.5 26.418 91.8815 26.418C92.239 26.418 92.5752 26.5101 92.8859 26.6954C93.001 26.7644 93.0575 26.8935 93.0575 27.0839C93.0575 27.3422 93.0224 27.4719 92.9508 27.4719C92.8943 27.4719 92.8054 27.4082 92.6821 27.2791C92.5589 27.1518 92.4308 27.0449 92.3 26.9606C92.1693 26.8759 91.9999 26.833 91.7904 26.833C91.5793 26.833 91.3968 26.8854 91.2421 26.9882C91.0874 27.0923 91.0105 27.2428 91.0105 27.4412C91.0105 27.6108 91.068 27.7372 91.1846 27.8202C91.3016 27.9029 91.4665 27.982 91.6827 28.0525L92.132 28.1613Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8375 29.8737C94.5844 29.6682 94.4263 29.3933 94.3671 29.0486L94.5249 29.0343C95.3312 28.9327 95.8868 28.8173 96.1893 28.6866C96.8487 28.4349 97.1789 28.0421 97.1789 27.5107C97.1789 27.148 97.0064 26.8621 96.6629 26.6527C96.4391 26.4953 96.162 26.416 95.8309 26.416C95.4344 26.416 95.0712 26.5204 94.74 26.726C94.4078 26.9345 94.1458 27.2145 93.9548 27.5687C93.7621 27.9217 93.667 28.3032 93.667 28.7129C93.667 29.2791 93.8546 29.7459 94.2259 30.114C94.5994 30.4813 95.0562 30.666 95.5956 30.666C96.0232 30.666 96.4142 30.5368 96.7694 30.2776C97.1132 30.0261 97.285 29.8051 97.285 29.6162C97.285 29.5155 97.2365 29.4647 97.1395 29.4647C97.0886 29.4647 96.9914 29.5352 96.8469 29.6791C96.7022 29.8212 96.5476 29.9408 96.3804 30.0384C96.2135 30.1359 95.9965 30.1839 95.7279 30.1839C95.3874 30.1839 95.0906 30.0806 94.8375 29.8737ZM96.5168 27.4982C96.5168 28.1625 95.791 28.5544 94.3408 28.6732V28.6735H94.3111C94.3111 28.1603 94.4386 27.726 94.6951 27.3747C94.9515 27.0213 95.3156 26.8455 95.7907 26.8455C96.007 26.8455 96.1806 26.9006 96.3161 27.0076C96.4493 27.116 96.5168 27.2796 96.5168 27.4982Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.526 29.921C101.526 29.9727 101.541 30.014 101.569 30.0476C101.599 30.0802 101.636 30.1052 101.683 30.1251C101.732 30.1448 101.763 30.1586 101.778 30.1673C101.873 30.2225 101.923 30.2827 101.923 30.3501C101.923 30.4041 101.902 30.4499 101.863 30.4862C101.822 30.5241 101.776 30.5432 101.722 30.5432H100.826C100.703 30.5432 100.62 30.5311 100.576 30.5072C100.531 30.4828 100.51 30.4314 100.51 30.3505C100.51 30.2745 100.558 30.2125 100.654 30.1677C100.678 30.1592 100.711 30.1473 100.752 30.1297C100.795 30.1141 100.83 30.0903 100.858 30.0567C100.888 30.0232 100.902 29.9783 100.902 29.9213V27.7043C100.902 27.1709 100.591 26.9039 99.9668 26.9039C99.6192 26.9039 99.3149 27.024 99.0542 27.2626C98.8784 27.4384 98.7895 27.7062 98.7895 28.0661V29.9213C98.7895 30.0272 98.8784 30.1094 99.0542 30.1677C99.1595 30.2021 99.2128 30.2624 99.2128 30.3505C99.2128 30.4044 99.193 30.4502 99.153 30.4865C99.1132 30.5244 99.0623 30.5435 99.003 30.5435H98.0906C97.9658 30.5435 97.8793 30.5313 97.8326 30.5075C97.785 30.4831 97.7611 30.4317 97.7611 30.3508C97.7611 30.2784 97.8138 30.2178 97.9197 30.168C97.9517 30.156 97.9873 30.1439 98.0283 30.1301C98.0669 30.1181 98.103 30.0956 98.1357 30.0636C98.1678 30.0316 98.1842 29.9845 98.1842 29.9216V27.7046C98.1842 27.5341 98.1686 27.4033 98.1399 27.3137C98.1113 27.222 98.0379 27.1604 97.9197 27.1243C97.7949 27.0745 97.7324 27.019 97.7324 26.9592C97.7324 26.8918 97.7997 26.7986 97.9329 26.6816C98.1624 26.5058 98.3026 26.418 98.3554 26.418C98.4754 26.418 98.5552 26.487 98.5957 26.6256C98.6351 26.7641 98.668 26.9452 98.6976 27.1672C99.0788 26.6678 99.5641 26.418 100.151 26.418C100.615 26.418 100.971 26.5609 101.222 26.8469C101.423 27.0813 101.525 27.4965 101.525 28.0942V29.921H101.526Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.716 24.9621C102.624 25.0514 102.58 25.1643 102.58 25.2998C102.58 25.4236 102.621 25.532 102.704 25.6271C102.788 25.7221 102.892 25.769 103.019 25.769C103.161 25.769 103.275 25.7232 103.362 25.6322C103.45 25.5405 103.493 25.4192 103.493 25.2687C103.493 25.1446 103.45 25.0412 103.364 24.9553C103.277 24.8691 103.17 24.8262 103.045 24.8262C102.916 24.8262 102.806 24.8709 102.716 24.9621ZM102.409 30.351C102.409 30.4784 102.501 30.5438 102.686 30.5438V30.5444H103.611C103.789 30.5444 103.878 30.479 103.878 30.3517C103.878 30.267 103.819 30.2078 103.707 30.169C103.593 30.1241 103.527 30.0773 103.505 30.0312C103.48 29.9495 103.466 29.7701 103.466 29.4936V27.7776C103.466 27.3512 103.457 27.0318 103.442 26.8198C103.417 26.68 103.395 26.5786 103.373 26.5149C103.352 26.4509 103.296 26.4183 103.202 26.4183C103.185 26.4183 103.08 26.4691 102.886 26.5697C102.6 26.6938 102.429 26.787 102.37 26.8471C102.334 26.8763 102.315 26.9142 102.315 26.9591C102.315 27.0262 102.378 27.0814 102.503 27.1243C102.67 27.1603 102.764 27.2105 102.786 27.2757C102.805 27.3412 102.824 27.5171 102.845 27.803V29.6177C102.845 29.7952 102.826 29.9237 102.788 30.0012C102.751 30.0786 102.673 30.1337 102.554 30.1682C102.457 30.2072 102.409 30.2664 102.409 30.351Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.816 30.0491C108.217 29.639 108.417 29.1292 108.417 28.5211C108.417 28.1421 108.326 27.7906 108.143 27.4668C107.96 27.1417 107.714 26.8863 107.401 26.6985C107.089 26.5101 106.75 26.416 106.386 26.416C106.028 26.416 105.691 26.5126 105.375 26.7072C105.058 26.9 104.805 27.162 104.618 27.4929C104.432 27.8229 104.338 28.1732 104.338 28.5486C104.338 28.9261 104.427 29.2782 104.607 29.603C104.786 29.9293 105.031 30.1882 105.339 30.3798C105.647 30.5713 105.982 30.666 106.343 30.666C106.924 30.666 107.414 30.4607 107.816 30.0491ZM107.759 28.5073C107.759 28.9843 107.644 29.3816 107.414 29.696C107.148 30.0663 106.796 30.2507 106.359 30.2507C105.925 30.2507 105.589 30.0907 105.354 29.7675C105.117 29.4453 104.998 29.0528 104.998 28.5893C104.998 28.2757 105.048 27.9871 105.148 27.7254C105.248 27.4627 105.401 27.2499 105.609 27.0881C105.817 26.9261 106.07 26.8451 106.371 26.8451C106.81 26.8451 107.151 27.0053 107.394 27.3239C107.638 27.6443 107.759 28.039 107.759 28.5073Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.028 29.8372C110.028 29.9491 110.05 30.0235 110.093 30.0578C110.136 30.0929 110.199 30.1249 110.279 30.1554C110.376 30.2077 110.424 30.2698 110.424 30.3369C110.424 30.4742 110.332 30.5438 110.147 30.5438H109.274C109.089 30.5438 108.996 30.4739 108.996 30.3369C108.996 30.2647 109.041 30.2077 109.129 30.1682C109.214 30.1423 109.282 30.1089 109.332 30.0701C109.381 30.0322 109.406 29.9548 109.406 29.8375V27.7773C109.406 27.4814 109.292 27.2728 109.064 27.1521C108.931 27.1073 108.863 27.0462 108.863 26.9731C108.863 26.8929 108.939 26.7967 109.09 26.6819C109.298 26.5061 109.448 26.4183 109.538 26.4183C109.677 26.4183 109.775 26.5188 109.83 26.7198C109.884 26.923 109.938 27.1863 109.989 27.5129C110.086 27.2603 110.239 27.016 110.451 26.7765C110.661 26.5376 110.872 26.418 111.086 26.418C111.394 26.418 111.546 26.5938 111.546 26.9452C111.546 27.1572 111.486 27.2631 111.363 27.2631C111.318 27.2631 111.239 27.2327 111.125 27.1735C111.01 27.1142 110.922 27.0842 110.86 27.0842C110.664 27.0842 110.467 27.2641 110.267 27.6243C110.107 27.8845 110.027 28.1833 110.027 28.5233V29.8372H110.028Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.604 26.8464C116.236 26.8464 115.95 27.0353 115.746 27.4143C115.543 27.7462 115.442 28.1613 115.442 28.661C115.442 29.0691 115.557 29.4222 115.786 29.7203C116.014 30.019 116.318 30.1682 116.697 30.1682C117.127 30.1682 117.465 30.0115 117.712 29.6981C117.82 29.5704 117.908 29.5067 117.977 29.5067C118.064 29.5067 118.109 29.5575 118.109 29.6585C118.109 29.8031 118.003 29.9719 117.793 30.1682C117.449 30.5014 117.048 30.6679 116.591 30.6679C116.222 30.6679 115.902 30.5802 115.627 30.4025C115.353 30.2262 115.145 29.9831 114.999 29.6729C114.853 29.3638 114.78 29.0174 114.78 28.6344C114.78 28.2406 114.865 27.8739 115.032 27.5328C115.2 27.1932 115.436 26.923 115.741 26.7195C116.045 26.5185 116.389 26.418 116.774 26.418C117.107 26.418 117.407 26.5145 117.673 26.7091C117.892 26.8641 118.003 27.0399 118.003 27.2366C118.003 27.3149 117.974 27.3894 117.916 27.4603C117.86 27.5311 117.796 27.5673 117.725 27.5673C117.639 27.5673 117.581 27.5534 117.553 27.5258C117.523 27.4999 117.463 27.4258 117.37 27.3065C117.242 27.14 117.127 27.0221 117.027 26.9522C116.928 26.8807 116.786 26.8464 116.604 26.8464Z",
    fill: "#333333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.872 30.0289C121.838 29.9472 121.821 29.7678 121.821 29.4913H121.821V28.1047C121.821 27.5382 121.644 27.1135 121.291 26.831C120.957 26.5545 120.549 26.416 120.063 26.416C119.696 26.416 119.36 26.4953 119.057 26.6527C118.836 26.7536 118.728 26.8743 118.728 27.0138C118.728 27.1608 118.807 27.2342 118.967 27.2342C119.015 27.2342 119.132 27.1794 119.322 27.069C119.573 26.911 119.82 26.831 120.063 26.831C120.362 26.831 120.621 26.927 120.84 27.117C121.061 27.3066 121.179 27.5584 121.198 27.8681L120.695 27.8424C120.102 27.8424 119.605 27.9716 119.205 28.2308C118.736 28.5505 118.502 28.9562 118.502 29.4472C118.502 29.8336 118.64 30.1342 118.915 30.3472C119.19 30.559 119.521 30.666 119.905 30.666C120.493 30.666 120.945 30.3989 121.265 29.8616V30.0854C121.265 30.2628 121.282 30.3844 121.313 30.4466C121.347 30.5093 121.432 30.5421 121.569 30.5421H121.936C122.149 30.5421 122.255 30.4767 122.255 30.3493C122.255 30.2647 122.198 30.2055 122.081 30.1665C121.976 30.1305 121.908 30.0842 121.872 30.0289ZM120.061 28.3456C120.317 28.269 120.576 28.2311 120.839 28.2311L121.198 28.2442V28.9506C121.198 29.3725 121.092 29.6757 120.882 29.8619C120.643 30.0857 120.339 30.197 119.969 30.197C119.761 30.197 119.563 30.1129 119.376 29.9472C119.234 29.8237 119.164 29.6427 119.164 29.407C119.164 29.1277 119.249 28.9001 119.421 28.7235C119.593 28.5486 119.806 28.4223 120.061 28.3456Z",
    fill: "#333333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M123.763 29.8372C123.763 29.9491 123.783 30.0235 123.826 30.0578C123.87 30.0929 123.932 30.1249 124.013 30.1554C124.111 30.2077 124.158 30.2698 124.158 30.3369C124.158 30.4742 124.065 30.5438 123.881 30.5438H123.008C122.822 30.5438 122.73 30.4739 122.73 30.3369C122.73 30.2647 122.775 30.2077 122.862 30.1682C122.948 30.1423 123.016 30.1089 123.066 30.0701C123.115 30.0322 123.139 29.9548 123.139 29.8375V27.7773C123.139 27.4814 123.025 27.2728 122.798 27.1521C122.664 27.1073 122.597 27.0462 122.597 26.9731C122.597 26.8929 122.674 26.7967 122.824 26.6819C123.033 26.5061 123.181 26.4183 123.272 26.4183C123.411 26.4183 123.509 26.5188 123.564 26.7198C123.618 26.923 123.672 27.1863 123.723 27.5129C123.819 27.2603 123.974 27.016 124.184 26.7765C124.396 26.5376 124.606 26.418 124.82 26.418C125.127 26.418 125.28 26.5938 125.28 26.9452C125.28 27.1572 125.219 27.2631 125.097 27.2631C125.052 27.2631 124.973 27.2327 124.858 27.1735C124.744 27.1142 124.656 27.0842 124.593 27.0842C124.398 27.0842 124.2 27.2641 124.001 27.6243C123.841 27.8845 123.762 28.1833 123.762 28.5233V29.8372H123.763Z",
    fill: "#333333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.742 29.8737C126.489 29.6682 126.331 29.3933 126.271 29.0486L126.429 29.0343C127.236 28.9327 127.79 28.8173 128.093 28.6866C128.754 28.4349 129.084 28.0421 129.084 27.5107C129.084 27.148 128.911 26.8621 128.568 26.6527C128.344 26.4953 128.066 26.416 127.736 26.416C127.34 26.416 126.976 26.5204 126.644 26.726C126.312 26.9345 126.051 27.2145 125.858 27.5687C125.667 27.9217 125.572 28.3032 125.572 28.7129C125.572 29.2791 125.758 29.7459 126.131 30.114C126.504 30.4813 126.96 30.666 127.5 30.666C127.928 30.666 128.319 30.5368 128.675 30.2776C129.017 30.0261 129.19 29.8051 129.19 29.6162C129.19 29.5155 129.142 29.4647 129.045 29.4647C128.994 29.4647 128.895 29.5352 128.752 29.6791C128.607 29.8212 128.453 29.9408 128.286 30.0384C128.119 30.1359 127.902 30.1839 127.632 30.1839C127.293 30.1839 126.996 30.0806 126.742 29.8737ZM128.422 27.4982C128.422 28.1625 127.696 28.5544 126.246 28.6732V28.6735H126.216C126.216 28.1603 126.344 27.726 126.599 27.3747C126.855 27.0213 127.221 26.8455 127.696 26.8455C127.911 26.8455 128.086 26.9006 128.22 27.0076C128.354 27.116 128.422 27.2796 128.422 27.4982Z",
    fill: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7065 28.4883H40.7305V29.1595H88.7065V28.4883Z",
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_473_10648",
    x1: 5.83979,
    y1: 26.3947,
    x2: 23.9599,
    y2: 26.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_473_10648",
    x1: 10.3359,
    y1: 31.1162,
    x2: 36.8916,
    y2: 31.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_473_10648",
    x1: 11.2319,
    y1: 17.6023,
    x2: 16.7212,
    y2: 22.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_473_10648",
    x1: -4.58127,
    y1: 20.5748,
    x2: -2.09931,
    y2: 38.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_473_10648",
    x1: 8.58087,
    y1: 22.183,
    x2: 3.26958,
    y2: 31.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_473_10648",
    x1: 39.5996,
    y1: 22.639,
    x2: 45.8357,
    y2: 22.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_473_10648",
    x1: 46.8068,
    y1: 22.4007,
    x2: 57.9661,
    y2: 22.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_473_10648",
    x1: 58.4185,
    y1: 22.4179,
    x2: 72.6567,
    y2: 22.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_473_10648",
    x1: 72.2994,
    y1: 22.5876,
    x2: 83.6531,
    y2: 22.5876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_473_10648",
    x1: 84.5439,
    y1: 22.4369,
    x2: 91.071,
    y2: 22.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_473_10648",
    x1: 93.4668,
    y1: 22.52,
    x2: 104.368,
    y2: 22.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_473_10648",
    x1: 106.246,
    y1: 22.5034,
    x2: 117.714,
    y2: 22.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_473_10648",
    x1: 118.199,
    y1: 22.4007,
    x2: 129.359,
    y2: 22.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.54e47f1a2ae175924060d09f0ae78503.svg";
export { ForwardRef as ReactComponent };